export default {
  title: 'Notifications',
  subtitle:
    "Choisissez ce que vous recevez de l'organisation {organization}. Vos choix ne valent que pour elle, et l'emportent sur ses réglages par défaut.",
  loadFailed: "Vos notifications n'ont pas pu être chargées.",
  empty: {
    title: 'Aucune notification pour vous ici',
    description:
      "Rien de ce que l'organisation envoie ne vous concerne pour l'instant : il faut pouvoir consulter un espace de travail, en modérer un, examiner les demandes d'inscription ou gérer les ventes d'une chaîne.",
  },
  mandatory: 'Obligatoire',
  mandatoryHint: 'Cette notification vous est due : son e-mail ne peut pas être désactivé.',
  everywhere: {
    workspace: 'Dans tous les espaces que vous consultez',
    website: 'Sur toutes les chaînes dont vous gérez les ventes',
  },
  reset: 'Revenir au défaut',
  kinds: {
    uploadReceived: {
      label: 'Nouveaux fichiers',
      description: 'Quand une vidéo ou un autre fichier est ajouté à un espace de travail que vous consultez.',
    },
    uploadPendingModeration: {
      label: 'Fichiers à valider',
      description:
        'Quand un fichier ajouté à un espace de travail modéré attend une validation avant que ses membres ne le voient.',
    },
    membershipRequestReceived: {
      label: "Nouvelles demandes d'inscription",
      description: "Quand quelqu'un demande à rejoindre l'organisation par son formulaire public.",
    },
    membershipRequestsWaiting: {
      label: "Demandes d'inscription en attente",
      description: 'Un rappel par semaine au plus, tant que des demandes attendent une réponse depuis sept jours.',
    },
    saleReceived: {
      label: 'Nouvelles ventes',
      description:
        'Quand une de vos chaînes vend un accès, une location ou un abonnement : un message par vente, jamais pour un renouvellement.',
    },
    contactMessageReceived: {
      label: 'Nouveaux messages',
      description:
        "Quand un visiteur écrit à l'une de vos chaînes depuis son formulaire de contact. Par e-mail, le formulaire envoie déjà chaque message à l'adresse de contact de la chaîne.",
      everywhere: 'Sur toutes les chaînes dont vous lisez les messages',
      websitesEmpty: "Vous n'avez fait aucun choix pour une chaîne en particulier.",
    },
    depositReceived: {
      label: 'Nouveaux dépôts',
      description:
        "Quand un membre dépose un fichier dans la boîte de dépôt de l'une de vos chaînes. Par e-mail seulement si vous l'activez.",
      everywhere: 'Sur toutes les chaînes dont vous traitez les dépôts',
      websitesEmpty: "Vous n'avez fait aucun choix pour une chaîne en particulier.",
    },
  },
  unknownKind: "Une notification que cette version de l'application ne sait pas encore décrire.",
  channels: {
    email: 'E-mail',
    inApp: "Dans l'application",
  },
  sources: {
    memberScoped: 'Votre choix pour cet espace',
    member: 'Votre choix',
    organization: "Défaut de l'organisation",
    registry: 'Défaut',
    none: 'Désactivé',
  },
  sourceHints: {
    memberScoped: "Vous l'avez choisi pour cet espace : il l'emporte sur votre choix pour toute l'organisation.",
    member: "Vous l'avez choisi pour toute l'organisation.",
    organization: "Réglé par l'organisation pour les personnes à qui cette notification est destinée.",
    registry: 'Le réglage par défaut de la plateforme.',
    none: "Vous ne la recevez que si vous l'activez.",
  },
  workspaces: {
    title: 'Espaces suivis',
    empty:
      'Vous ne suivez aucun espace en particulier. Pour en suivre un, ouvrez-le et cliquez sur la cloche à côté de son nom.',
    followed: 'Suivi',
    excluded: 'Exclu',
    unfollow: 'Ne plus suivre',
    removeException: "Retirer l'exception",
  },
  websites: {
    title: 'Réglages par chaîne',
    empty:
      "Vous n'avez fait aucun choix pour une chaîne en particulier. Le réglage d'une chaîne se trouve dans ses paramètres de monétisation : « Me prévenir de chaque vente ».",
    enabled: 'Activé',
    disabled: 'Désactivé sur cette chaîne',
    clear: 'Retirer ce choix',
  },
  refusals: {
    mandatory: 'Cette notification est obligatoire par e-mail.',
    notEligible: 'Cette notification ne vous concerne plus.',
    notSelectable: "Ce canal n'est pas encore disponible.",
    failed: "Le changement n'a pas pu être enregistré.",
  },
}
